import ConfirmSheetThankYou from './ConfirmSheetThankYou';

export default ConfirmSheetThankYou;
